var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon Frame",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Vector 70",
    d: "M0,0V14H18V2H9L7,0Z",
    transform: "translate(3 5)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Vector 84",
    d: "M14-7,7,0,0-7",
    transform: "translate(19 12) rotate(180)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Rectangle 86",
    width: 0.01,
    height: 0.01,
    transform: "translate(7.5 9.5)",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon_image.2c1de9ae61008ad0fac9eb2c56f0fd22.svg";
export { ForwardRef as ReactComponent };